import React from 'react';

// Hooks
import useThemeVersion from '@/hooks/useThemeVersion';

// Types
import classNames from 'classnames';

type ComponentProps = {
  className?: string;
  leftItems?: React.ReactNode[];
  middleItems?: React.ReactNode[];
  midRightItems?: React.ReactNode[];
  farRightItems?: React.ReactNode[];
};

type Props = ComponentProps;

const ComparisonTopBarNavigation = ({ className, leftItems, middleItems, midRightItems, farRightItems }: Props) => {
  const { isLightVersion } = useThemeVersion();
  const classes = classNames('comparison-top-bar-navigation d-flex align-items-center', className, {
    'is-light': isLightVersion,
  });

  return (
    <nav className={classes} data-testid="comparison-top-bar-navigation">
      <ul className="top-bar-nav-left">
        {leftItems?.map((node, index) => (
          <li key={index}>{node}</li>
        ))}
      </ul>
      <ul className="top-bar-nav-middle">
        {middleItems?.map((node, index) => (
          <li key={index}>{node}</li>
        ))}
      </ul>
      <ul className="top-bar-nav-mid-right">
        {midRightItems?.map((node, index) => (
          <li key={index}>{node}</li>
        ))}
      </ul>
      <ul className="top-bar-nav-far-right">
        {farRightItems?.map((node, index) => (
          <li key={index}>{node}</li>
        ))}
      </ul>
    </nav>
  );
};

export default ComparisonTopBarNavigation;
